module.exports = __webpack_public_path__ + "static/img/feihe.2869125.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/feihe.jpg
// module id = NCMo
// module chunks = 0